import { render, staticRenderFns } from "./VolunteerList.vue?vue&type=template&id=3549ed80&scoped=true"
import script from "./VolunteerList.vue?vue&type=script&lang=js"
export * from "./VolunteerList.vue?vue&type=script&lang=js"
import style0 from "./VolunteerList.vue?vue&type=style&index=0&id=3549ed80&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3549ed80",
  null
  
)

export default component.exports